import { render, staticRenderFns } from "./lessonTime.vue?vue&type=template&id=823bf15e&scoped=true"
import script from "./lessonTime.vue?vue&type=script&lang=js"
export * from "./lessonTime.vue?vue&type=script&lang=js"
import style0 from "./lessonTime.vue?vue&type=style&index=0&id=823bf15e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823bf15e",
  null
  
)

export default component.exports